<!-- OE-265: cards on the shared layout grid (12 fine columns by width, 40px rows); "Edit layout"
     shows the drag handles and resize corners (layout-grid.component.ts). -->
<div class="mt-dashboard" #gridContainer>
    <div class="dashboard-header">
        <h3 class="dashboard-title">{{ dashboardName | titlecase }}</h3>
        <div class="dashboard-actions">
            <button mat-icon-button matTooltip="Add widget" aria-label="Add a widget" (click)="openAddWidgetDialog()">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button
                *ngIf="widgets.length > 0"
                mat-icon-button
                [class.active]="editMode"
                [matTooltip]="editMode ? 'Done editing' : 'Edit layout'"
                [attr.aria-label]="editMode ? 'Done editing the layout' : 'Edit the layout'"
                [attr.aria-pressed]="editMode"
                (click)="editMode = !editMode"
            >
                <mat-icon>{{ editMode ? 'check_circle' : 'edit' }}</mat-icon>
            </button>
        </div>
    </div>

    <p class="edit-hint" *ngIf="editMode">Drag a card by its handle to move it; drag its corner to resize it.</p>

    <shared-layout-grid
        *ngIf="widgets.length > 0; else dashboardWithoutContent"
        class="mt-dashboard-grid"
        [items]="layoutItems"
        [editMode]="editMode"
        (moved)="onLayoutMoved($event)"
        (resized)="onLayoutResized($event)"
    >
        <ng-template let-item let-startDrag="startDrag">
            <mat-card class="widget-card" *ngIf="widgetById(item.id) as widget">
                <div class="widget-header">
                    <div class="widget-title-area">
                        <mat-icon
                            *ngIf="editMode"
                            class="drag-handle"
                            aria-label="Drag to move this card"
                            (pointerdown)="startDrag($event)"
                            >drag_indicator</mat-icon
                        >
                        <div class="widget-titles">
                            <span class="widget-title">{{ widget.title }}</span>
                            <span class="widget-subtitle" *ngIf="widget.subtitle">{{ widget.subtitle }}</span>
                        </div>
                    </div>
                    <button
                        mat-icon-button
                        class="widget-action-btn"
                        aria-label="Widget options"
                        matTooltip="Options"
                        [matMenuTriggerFor]="menu"
                        (click)="updateMenuOptions(widget)"
                    >
                        <mat-icon>more_vert</mat-icon>
                    </button>
                </div>

                <div class="widget-content mt-widget-content">
                    <div class="center-above-widget loader-backdrop" *ngIf="widget.isLoading || widget.hasError">
                        <mat-spinner *ngIf="widget.isLoading" class="spinner" diameter="50"></mat-spinner>
                        <div *ngIf="widget.hasError" class="error-info">
                            <span [ngSwitch]="widget.typeOfError">
                                <div *ngSwitchCase="'NOT_DATE_PROFILE'">
                                    <p class="error-text">
                                        The selected date profile for this widget is not available. Please select a
                                        different date profile by adjusting the settings.
                                    </p>
                                    <button
                                        mat-raised-button
                                        color="primary"
                                        (click)="openSettingsDialogForWidget(widget)"
                                    >
                                        <mat-icon>settings</mat-icon> Open Settings
                                    </button>
                                </div>
                                <p *ngSwitchDefault class="error-text mt-2">
                                    There was an error loading the widget. Please try again later.
                                </p>
                            </span>
                        </div>
                    </div>
                    <shared-dashboard-intermediate
                        [data]="widget.data"
                        [type]="widget.type"
                        [refreshScale]="refreshScale"
                        (clientAbcGroupExpand)="onClientAbcGroupExpand($event, widget)"
                        (fromDateChange)="onWidgetDateChange(widget, 'from', $event)"
                        (toDateChange)="onWidgetDateChange(widget, 'to', $event)"
                    ></shared-dashboard-intermediate>
                </div>
            </mat-card>
        </ng-template>
    </shared-layout-grid>
</div>

<ng-template #dashboardWithoutContent>
    <div class="dashboard-empty">
        <mat-icon class="empty-icon">dashboard_customize</mat-icon>
        <h4>No widgets yet</h4>
        <p>Add a 7R graph or a Client ABC list with the <mat-icon inline>add_circle_outline</mat-icon> button above.</p>
    </div>
</ng-template>

<!-- Dynamically generated menu. -->
<mat-menu #menu="matMenu">
    <ng-container *ngFor="let item of menuOptions">
        <!-- Embedding menu option. -->
        <ng-container *ngIf="item.subMenuItems; else standardOptions">
            <button
                mat-menu-item
                (click)="item.action()"
                [disabled]="item.disabled"
                [matMenuTriggerFor]="secondaryMenu"
            >
                <mat-icon [color]="item.colour">{{ item.icon }}</mat-icon>
                <span>{{ item.display }}</span>
            </button>

            <!-- Regular button menu option. -->
            <mat-menu #secondaryMenu="matMenu">
                <button
                    *ngFor="let item of item.subMenuItems"
                    mat-menu-item
                    [ngClass]="{ 'item-bold': item.selected }"
                    (click)="item.action()"
                >
                    {{ item.display }}
                </button>
            </mat-menu>
        </ng-container>

        <!-- Regular button and icon menu option. -->
        <ng-template #standardOptions>
            <button mat-menu-item (click)="item.action()" [disabled]="item.disabled">
                <mat-icon [color]="item.colour">{{ item.icon }}</mat-icon>
                <span>{{ item.display }}</span>
            </button>
        </ng-template>
    </ng-container>
</mat-menu>
